export const USER_ROLE = {
  ADMIN: 'Admin',
  SUPER_ADMIN: 'Super Admin',
  GUEST: 'Guest',
} as const;

export const USER_STATUS = {
  ACTIVE: 'Active',
  REVOKED: 'Revoked',
  ADDED: 'Added',
};

export type UserRole = keyof typeof USER_ROLE;
export type UserStatus = keyof typeof USER_STATUS;

export interface User {
  readonly id: string;
  readonly email: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly avatar: string;
  readonly role: UserRole;
  readonly status: UserStatus;
  readonly createdAt: string;
  readonly updatedAt: string;
}
